
export interface ExportOption {
    name?: string
    type?: number
    group?: string
    fileFormats: ExportFileFormats[]
    dateTypes: ExportDateTypes[]
    isNew?: boolean
    isEmailSupported?: boolean
    isDateRangeSupported?: boolean
}

export const ExportFileFormats = {
    Pdf: 1,
    Xlsx: 2,
    Csv: 3,
    Html: 4
}
export type ExportFileFormats = typeof ExportFileFormats[keyof typeof ExportFileFormats]

export const ExportDateTypes = {
    ContractedDate: 1,
    InsuranceStartDate: 2,
    ParamsCreatedDate: 3
}
export type ExportDateTypes = typeof ExportDateTypes[keyof typeof ExportDateTypes]

export interface ExportRequest {
    product?: number
    userId?: string
    exportType: number
    dateType: ExportDateTypes
    fileFormat: ExportFileFormats
    dateFrom: Date
    dateTo: Date
    ouId?: number
    email?: string
    includeStorno?: boolean
}